import { clearPersistedOverlays } from 'ui-lib/modules/Map/map-tools/OverlaysMapTool/hooks/useOverlaysMapTool';

import { AccessToken } from '../../../services/access-token';
import { UserCurrentCompany } from '../../../services/user-company';
import { UserImpersonation } from '../../../services/user-impersonation';

const AUTH_STORAGE_KEYS = {
  APP_VERSION: 'appVersion',
  PERSISTED_REDUX_STATE: 'persist:root',
  TOTAL_EVENT_COUNT: 'total_event_count',
  TOTAL_RISK_EVENTS_CHART_TYPE: 'truckshieldTotalRiskEventsChartType',
};

export const clearAuthData = () => {
  AccessToken.clearTokens();
  UserImpersonation.clearImpersonationData();
  UserCurrentCompany.clearCompany();
};

export const clearLocalStorage = () => {
  localStorage.removeItem(AUTH_STORAGE_KEYS.TOTAL_RISK_EVENTS_CHART_TYPE);
  localStorage.removeItem(AUTH_STORAGE_KEYS.TOTAL_EVENT_COUNT);
  localStorage.removeItem(AUTH_STORAGE_KEYS.APP_VERSION);
  localStorage.removeItem(AUTH_STORAGE_KEYS.PERSISTED_REDUX_STATE);

  clearPersistedOverlays();
};
